module.exports = __webpack_public_path__ + "static/017-22b698cba76212ba229cb1f1fc85bd5a.jpg";